import React, {
  useCallback,
  useContext,
  useState
} from 'react';

import { NoPersonWarning } from '../../components';
import { IdentityContext } from '../../context';
import { useIndex, useUpdate } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';
import { NewPOAGuard } from './new-poa-guard';

export function NewPOAProvider() {
  const { person } = useContext(IdentityContext);
  const { data, loading, update } = useIndex('power_of_attorney', { person_id: person?.id });
  const { handleUpdate } = useUpdate('power_of_attorney');
  const [ initLoad, setInitLoad ] = useState(true);
  const [ checkpoint, setCheckpoint ] = useState(localStorage.getItem('poa:checkpoint') || '');

  const updateCheckpoint = useCallback(path => {
    localStorage.setItem('poa:checkpoint', path);
    setCheckpoint(path);
  }, []);

  if (loading) {
    return <div>Loading power of attorney...</div>;
  }

  if (!person) {
    return <NoPersonWarning />;
  }
  
  const powerOfAttorney = data[0];
  
  return (
    <NewPOAContext.Provider 
      value={{ 
        powerOfAttorney, 
        update, 
        handleUpdate,
        checkpoint, 
        updateCheckpoint,
        setPowerOfAttorney: () => {} 
      }}
    >
      <NewPOAGuard initLoad={initLoad} setInitLoad={setInitLoad} />
    </NewPOAContext.Provider>
  );
}
